import {useMemo} from "react";

import {IOfferDetail} from "../../offer/types/IOfferDetail";
import {OfferType} from "../../offer/types/OfferType";
import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {IBoosterPropertyType} from "../types/IBoosterPropertyType";

export interface IUsePropertyTypeProps {
    property?: IPropertyDetail;
    offer?: IOfferDetail;
}

export const usePropertyType = (props: IUsePropertyTypeProps) => {
    return useMemo(() => {
        if (props.property?.offer?.type) {
            return props.property.offer.type === OfferType.HOUSE ? IBoosterPropertyType.House : IBoosterPropertyType.Flat;
        }

        if (props.offer?.type) {
            return props.offer.type === OfferType.HOUSE ? IBoosterPropertyType.HouseInvestment : IBoosterPropertyType.FlatInvestment;
        }

        return null;
    }, [props.property?.offer?.type, props.offer?.id]);
};
import {useMemo} from "react";

import {IOfferDetail} from "../../offer/types/IOfferDetail";
import {OfferType} from "../../offer/types/OfferType";
import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {IBoosterPropertyType} from "../types/IBoosterPropertyType";

export interface IUsePropertyTypeProps {
    property?: IPropertyDetail;
    offer?: IOfferDetail;
}

export const usePropertyType = (props: IUsePropertyTypeProps) => {
    return useMemo(() => {
        if (props.property?.offer?.type) {
            return props.property.offer.type === OfferType.HOUSE ? IBoosterPropertyType.House : IBoosterPropertyType.Flat;
        }

        if (props.offer?.type) {
            return props.offer.type === OfferType.HOUSE ? IBoosterPropertyType.HouseInvestment : IBoosterPropertyType.FlatInvestment;
        }

        return null;
    }, [props.property?.offer?.type, props.offer?.id]);
};
